import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { Box, Divider, FormattedCurrency, FormattedDate, HStack, Link, Text, Typography } from "components/ui";
import { Ban, CircleEllipsis, Ellipsis, MapPin, Repeat, ShoppingCart, Speech } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import { truncateText } from "utils/globalFunctions";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { Menu, MenuOption, MenuOptions, MenuTrigger } from "react-native-popup-menu";

type Props = {
	dataList: any;
};

const InvoiceTable = ({ dataList }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");

	if (!dataList || dataList.length === 0) {
		return (
			<Box gap={16} paddingVertical={28} paddingHorizontal={20}>
				<Typography.H3>No invoices found</Typography.H3>
				<Typography.ParagraphSmall sx={{ lineHeight: 21 }} weight="normal">
					You don't have any invoices yet. Your invoices will appear here once they are generated.
				</Typography.ParagraphSmall>
			</Box>
		);
	}

	return (
		<GridContainer
			noPadding
			style={{
				marginLeft: 0,
				maxWidth: "100%",
				marginBottom: 30,
			}}
		>
			{!isMobile && (
				<Row style={{ marginLeft: 0, marginRight: 0, marginBottom: 14, width: "100%" }}>
					<Col>
						<Text>Document</Text>
					</Col>
					<Col>
						<Text>Date</Text>
					</Col>
					<Col>
						<Text>Amount</Text>
					</Col>
				</Row>
			)}

			{dataList.map((order: any) => {
				return (
					<Box position="relative" key={order.documentNumber}>
						<Link
							href={`/finance/invoice/${order.documentNumber}`}
							key={order.documentNumber}
							component={(hovered: boolean) => {
								var styleData = { marginLeft: 0, marginRight: 0, paddingHorizontal: isMobile ? 0 : 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0" };

								if (hovered) {
									// @ts-ignore
									styleData = { ...styleData, backgroundColor: "#E1E9F0" };
								}
								if (isMobile) {
									return (
										<Row style={styleData} key={order.documentNumber}>
											<Col>
												<Row style={{ paddingBottom: 6 }}>
													<Col style={{ flexDirection: "row", justifyContent: "space-between" }}>
														<HStack gap={8} alignItems="center">
															<ShoppingCart color={resolvedPrimarylight} />
															<Text>{order.documentNumber}</Text>
														</HStack>
														<HStack gap={8} alignItems="center">
															<FormattedDate sx={{ color: "$neutral400", fontSize: 14 }} variant="DD/MMM" date={order.dateUtc} />
															<Box
																opacity={0}
																borderWidth={1}
																borderColor="#8298AB"
																alignItems="center"
																borderRadius={"$full"}
																justifyContent="center"
																bg="#E1E9F0"
																width={"$full"}
																maxWidth={38}
																marginLeft="auto"
															>
																<Ellipsis color="#8298AB" />
															</Box>
														</HStack>
													</Col>
												</Row>

												<Row style={{ paddingBottom: 6 }}>
													<Col style={{ flexDirection: "row", justifyContent: "space-between" }}>
														<FormattedCurrency sx={{ fontWeight: "bold" }} amount={300} />
													</Col>
												</Row>
											</Col>
										</Row>
									);
								}
								return (
									<Row style={styleData} key={order.documentNumber}>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8} alignItems="center">
												<ShoppingCart color={resolvedPrimarylight} />
												<Text>{order.documentNumber}</Text>
												{(order.type == "cart" || order.status == "Awaiting Approval") && (
													<Box justifyContent="center" alignItems="center" bg="$errormain" width={6} height={6} borderRadius={"$full"}>
														<Text color="$basicwhite"></Text>
													</Box>
												)}
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<FormattedDate variant="DD/MM/YYYY" date={order.transactionDateUtc} />
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<FormattedCurrency sx={{ fontWeight: "bold" }} amount={order.total} />
											</HStack>
										</Col>
									</Row>
								);
							}}
						></Link>
					</Box>
				);
			})}
		</GridContainer>
	);
};

export default InvoiceTable;
